import { TFeatureFlagNames } from "config";
import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";
import { find } from "lodash-es";

export const getFeatureFlags = (state: RootState) => state.featureFlags;

export const getIsBeneficiaryPacketEmailEnabled = createSelector(getFeatureFlags, featureFlags => {
  const beneficiaryPacketEmailFlag = find(featureFlags, {
    name: "wysh-insurance-beneficiary-packet-email",
  });

  return beneficiaryPacketEmailFlag?.enabled;
});

export const getFeatureFlagByName = createSelector(
  [getFeatureFlags, (_state: RootState, featureFlagName: TFeatureFlagNames) => featureFlagName],
  (featureFlags, featureFlagName) => {
    const foundFeatureFlag = find(featureFlags, { name: featureFlagName });
    return foundFeatureFlag?.enabled || false;
  }
);
